import * as constants from './constants'

const INITIAL_STATE = {
  loading: false,
  stadiums: {
    meta: {
      code: 200,
      message: '',
      errors: []
    },
    data: {
      data: [],
      pagination: {
        page: 1,
        limit: 10,
        total_page: 1,
        total_data: 1
      }
    }
  },
  profiles: {
    meta: {
      code: 200,
      message: '',
      errors: []
    },
    data: {
      data: [],
      pagination: {
        page: 1,
        limit: 10,
        total_page: 1,
        total_data: 1
      }
    }
  },
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.SET_LOADING:
      return Object.assign({}, state, {
        loading: action.data
      })
    case constants.SET_STADIUM_DD:
      return Object.assign({}, state, {
        stadiums: action.data
      })
    case constants.SET_PROFILE_DD:
      return Object.assign({}, state, {
        profiles: action.data
      })
    default: return state
  }
}
